if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCleanGallery);
} else {
  initCleanGallery();
}

function initCleanGallery() {
  const container = document.querySelector('.clean-gallery-container');
  if (!container) return;

  const mainSelector = '.clean-gallery-main';
  const thumbsSelector = '.clean-gallery-thumbs';

  // Check if Swiper is defined
  const checkDeps = setInterval(() => {
    if (typeof Swiper !== 'undefined') {
      clearInterval(checkDeps);
      startGallery(container, mainSelector, thumbsSelector);
    }
  }, 100);
}

function startGallery(container, mainSelector, thumbsSelector) {

  // Initialize Thumbs Slider
  const galleryThumbs = new Swiper(thumbsSelector, {
    spaceBetween: 10,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
  });

  // Initialize Main Slider
  const galleryMain = new Swiper(mainSelector, {
    spaceBetween: 0,
    loop: true, // Loop back to first/last slide
    navigation: {
      nextEl: '.clean-gallery-next',
      prevEl: '.clean-gallery-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
    on: {
      slideChange: function () {
        // Stop videos when sliding away
        const slides = this.slides;
        slides.forEach(slide => {
          const video = slide.querySelector('video');
          if (video) video.pause();
        });
      }
    }
  });

  // Expose instance for variant updates
  window.cleanGallery = galleryMain;

  // Listen for variant changes
  document.addEventListener('variant:change', function (e) {
    const variant = e.detail && e.detail.variant;
    if (variant && variant.featured_media) {
      const mediaId = variant.featured_media.id;
      const slideIndex = findSlideIndexByMediaId(mediaId);
      if (slideIndex >= 0) {
        galleryMain.slideTo(slideIndex);
      }
    }
  });

  // Initialize PhotoSwipe Lightbox using theme's library
  initPhotoSwipeLightbox(container, galleryMain);
}

function initPhotoSwipeLightbox(container, swiperInstance) {
  // Check if MinimogLibs PhotoSwipeLightbox is available
  if (typeof MinimogLibs === 'undefined' || typeof MinimogLibs.PhotoSwipeLightbox === 'undefined') {
    console.warn('MinimogLibs.PhotoSwipeLightbox not available, zoom disabled');
    return;
  }

  const slides = container.querySelectorAll('.clean-gallery-main .swiper-slide');

  // Build data source for PhotoSwipe
  const data = [];
  slides.forEach((slide, index) => {
    const mediaType = slide.dataset.mediaType;
    const img = slide.querySelector('img');

    if (mediaType === 'image' && img) {
      data.push({
        src: img.src.replace(/width=\d+/, 'width=2000'),
        width: parseInt(img.getAttribute('width')) || 1000,
        height: parseInt(img.getAttribute('height')) || 1000,
        alt: img.alt || '',
        id: index
      });
    } else {
      // For video/model, add HTML content
      data.push({
        html: `<div class="pswp__${mediaType || 'media'}">${slide.innerHTML}</div>`,
        type: mediaType,
        id: index
      });
    }
  });

  const options = {
    dataSource: data,
    bgOpacity: 1,
    close: false,
    zoom: false,
    arrowNext: false,
    arrowPrev: false,
    counter: true,
    preloader: true,
    // Disable animation to avoid flash/flicker
    showHideAnimationType: 'none',
    showAnimationDuration: 0,
    hideAnimationDuration: 0,
    zoomAnimationDuration: 0,
    pswpModule: MinimogLibs.PhotoSwipeLightbox.PhotoSwipe,
  };

  const lightbox = new MinimogLibs.PhotoSwipeLightbox(options);

  // Add thumbnail filter
  lightbox.addFilter('thumbEl', (thumbEl, { id }, index) => {
    return slides[id]?.querySelector('img') || thumbEl;
  });

  lightbox.addFilter('placeholderSrc', (placeholderSrc, { data: { id } }) => {
    const el = slides[id]?.querySelector('img');
    return el ? el.src : placeholderSrc;
  });

  // Sync with swiper on lightbox slide change
  lightbox.on('change', () => {
    if (window.pauseAllMedia) window.pauseAllMedia(container);
    const currIndex = lightbox.pswp.currIndex;
    swiperInstance.slideTo(currIndex, 100, false);
  });

  // Register UI elements
  const uiElements = [
    {
      name: 'm-close',
      order: 11,
      isButton: true,
      appendTo: 'root',
      html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
      onClick: (event, el, pswp) => pswp.close(),
    },
    {
      name: 'm-arrowNext',
      order: 12,
      isButton: true,
      appendTo: 'root',
      html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
      onClick: (event, el, pswp) => pswp.next(),
    },
    {
      name: 'm-arrowPrev',
      order: 10,
      isButton: true,
      appendTo: 'root',
      html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
      onClick: (event, el, pswp) => pswp.prev(),
    },
    {
      name: 'thumbnails',
      order: 13,
      isButton: false,
      appendTo: 'root',
      onInit: (el, pswp) => {
        let thumbsHTML = '';
        slides.forEach((slide, idx) => {
          const img = slide.querySelector('img');
          const src = img ? img.src : '';
          thumbsHTML += `<div class="pswp__thumbnail-item ${idx === 0 ? 'active' : ''}" data-idx="${idx}">
            <img src="${src}" loading="lazy" />
          </div>`;
        });
        el.innerHTML = thumbsHTML;
        el.className = 'pswp__custom-thumbnails';

        const items = el.querySelectorAll('.pswp__thumbnail-item');
        items.forEach(item => {
          item.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            const idx = parseInt(item.dataset.idx);
            pswp.goTo(idx);
          });
        });

        pswp.on('change', () => {
          items.forEach(i => i.classList.remove('active'));
          const curr = pswp.currIndex;
          const activeItem = el.querySelector(`.pswp__thumbnail-item[data-idx="${curr}"]`);
          if (activeItem) {
            activeItem.classList.add('active');
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      }
    }
  ];

  lightbox.on('uiRegister', () => {
    uiElements.forEach(element => lightbox.pswp.ui.registerElement(element));
  });

  // Initialize the lightbox
  lightbox.init();

  // Handle clicks on slides to open lightbox
  container.addEventListener('click', (e) => {
    const slide = e.target.closest('.clean-gallery-main .swiper-slide');
    if (!slide) return;

    const mediaType = slide.dataset.mediaType;
    // Only open for images
    if (mediaType === 'image' || !mediaType) {
      e.preventDefault();
      const slides = container.querySelectorAll('.clean-gallery-main .swiper-slide');
      const index = Array.from(slides).indexOf(slide);
      if (index >= 0) {
        lightbox.loadAndOpen(index);
      }
    }
  });

  // Set zoom cursor
  slides.forEach(slide => {
    if (slide.dataset.mediaType === 'image' || !slide.dataset.mediaType) {
      slide.style.cursor = 'zoom-in';
    }
  });
}

function findSlideIndexByMediaId(mediaId) {
  const slides = document.querySelectorAll('.clean-gallery-main .swiper-slide');
  for (let i = 0; i < slides.length; i++) {
    if (slides[i].dataset.mediaId == mediaId) {
      return i;
    }
  }
  return -1;
}
